import { DevicePhoneSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const DevicePhoneIcon = makeIcon(DevicePhoneSvgIcon, 'DevicePhoneIcon')`
  position: relative;
  top: 0.1em;

  rect {
    stroke: currentColor;
  }
  circle {
    fill: currentColor;
  }
`;
